<template>
  <div class="filters__group">
    <p v-if="group.label" class="filters__group__title mb-2">
      <small>{{ group.label }}</small>
    </p>

    <p v-if="group.disclaimer" class="filters__disclaimer mb-2">
      <span class="d-flex align-items-center">
        {{ group.disclaimer.label }}
        <vb-icon
          v-if="group.disclaimer.tooltip"
          v-b-popover.hover.top="group.disclaimer.tooltip"
          :name="'info'"
          :color="sass('gray-500')"
          :size="16"
          class="ml-1 cursor-pointer"
        />
      </span>
      <span
        v-if="group.disclaimer.description"
        class="filters__section__subtitle"
      >
        {{ group.disclaimer.description }}
      </span>
    </p>

    <template v-for="node in group.filters">
      <slot name="node" :node="node">
        <filter-node
          :key="`node-${node.id}`"
          :node="node"
          :selections="selections"
          :single_switch="single_switch"
          :bucket_transform="bucket_transform"
          :round_bounds="round_bounds"
          :unbounded_range="unbounded_range"
          :widget_key="widget_key"
          @change="(event) => $emit('change', event)"
        />
      </slot>
    </template>

    <filter-group
      v-for="sub_category in group.sub_categories"
      :key="`group-${sub_category.id}`"
      :group="sub_category"
      :selections="selections"
      :single_switch="single_switch"
      :bucket_transform="bucket_transform"
      :round_bounds="round_bounds"
      :unbounded_range="unbounded_range"
      :widget_key="widget_key"
      @change="(event) => $emit('change', event)"
    >
      <template #node="slot_props">
        <slot name="node" v-bind="slot_props">
          <filter-node
            :key="`node-${slot_props.node.id}`"
            :node="slot_props.node"
            :selections="selections"
            :single_switch="single_switch"
            :bucket_transform="bucket_transform"
            :round_bounds="round_bounds"
            :unbounded_range="unbounded_range"
            :widget_key="widget_key"
            @change="(event) => $emit('change', event)"
          />
        </slot>
      </template>
    </filter-group>
  </div>
</template>

<script>
  import FilterNode from '@components/blocks/filters/filter-node.vue';

  export default {
    name: 'filter-group',

    components: {
      'filter-node': FilterNode,
    },

    props: {
      group: {
        type: Object,
        required: true,
      },
      selections: {
        type: Object,
        default: () => ({}),
      },
      single_switch: {
        type: Boolean,
        default: false,
      },
      bucket_transform: {
        type: Function,
        default: null,
      },
      round_bounds: {
        type: Boolean,
        default: false,
      },
      unbounded_range: {
        type: Boolean,
        default: false,
      },
      widget_key: {
        type: [String, Number],
        default: 0,
      },
    },
  };
</script>

<style lang="scss">
  .filters__group {
    &:not(:last-child) {
      margin-bottom: map-get($spacers, 3);
    }

    &__title {
      color: $gray-600;
      font-weight: $vb-font-weight-semibold;
    }
  }
</style>
